
export function getToken() {
}

export function setToken(token) {
}

export function removeToken() {
}

export function encode(txt){
  return  window.btoa(window.btoa(window.btoa(window.btoa(txt))))
}

export function decode(txt){
  return  window.atob(window.atob(window.atob(window.atob(txt) )))
}
